import {Params} from '@angular/router';

import {Model} from './model';
import {RoleModel} from './role.model';
import {OrganizationModel} from './organization.model';
import {SportModel} from './sport.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'userId',
  name: 'name',
  lastName: 'lastName',
  email: 'email',
  numOrganizations: 'numOrganizations',
  roles: 'roles',
  organization: 'organization',
  sport: 'sport',
};

export class TokenUserModel extends Model {
  name!: string;
  lastName!: string;
  email!: string;
  numOrganizations!: number;
  roles?: RoleModel[];
  organization?: OrganizationModel;
  sport?: SportModel;

  get fullName(): string {
    return `${this.name} ${this.lastName}`.trim();
  }

  static getInstance(data: Params): TokenUserModel {
    const model = new TokenUserModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'roles') {
        if (Array.isArray(data[propsMapping[prop]])) {
          (model as Params)[prop] = data[propsMapping[prop]].map((item: Params) => {
            return RoleModel.getInstance(item);
          });
        }
      } else if (prop === 'organization') {
        (model as Params)[prop] = OrganizationModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'sport') {
        (model as Params)[prop] = SportModel.getInstance(data[propsMapping[prop]]);
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    if (!Array.isArray(model.roles)) {
      model.roles = [];
    }

    return model;
  }
}
